import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ReactQueryDevtools } from 'react-query/devtools';
import {
  LeagueProvider,
  QueryClientProvider,
} from '@highmark-web/highmark-common';
import { AppRoutes } from 'common/routes';
import { config } from './init-config';

export function App() {
  return (
    <BrowserRouter>
      <QueryClientProvider>
        <LeagueProvider config={config}>
          <AppRoutes />
          <ReactQueryDevtools />
        </LeagueProvider>
      </QueryClientProvider>
    </BrowserRouter>
  );
}
